import Controller from '@ember/controller';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { task } from 'ember-concurrency';
import type FlashMessagesService from 'garaje/services/flash-messages';
import type SigmaUrlService from 'garaje/services/sigma-url';
import type StateService from 'garaje/services/state';
import { Workbook } from 'garaje/utils/sigma-workbooks';

export default class AnalyticsParkingController extends Controller {
  @service declare flashMessages: FlashMessagesService;
  @service declare state: StateService;
  @service declare sigmaUrl: SigmaUrlService;

  @tracked isError = false;

  fetchSigmaUrlTask = task({ drop: true }, async () => {
    const {
      currentCompany: { id: companyId },
      currentLocation: { id: locationId },
    } = this.state;
    try {
      const result = await this.sigmaUrl.getLocationSigmaUrl(companyId, locationId, Workbook.LOCATION_PARKING);
      return result;
    } catch (e) {
      this.flashMessages.showAndHideFlash('error', 'Error loading dashboard');
      this.isError = true;
      // eslint-disable-next-line no-console
      console.error(e);
      return;
    }
  });

  get sigmaIframeUrl(): string | null | undefined {
    return this.fetchSigmaUrlTask.last?.value;
  }
}
